import postscribe from 'postscribe';
import AbstractDriver from './abstract-driver';

/* eslint no-undef: "error" */
class MouseFlow extends AbstractDriver
{
    constructor()
    {
        super();

        this.firstLoad = false;
    }

    init(config)
    {
        if (!this.firstLoad)
            this._loadScript(config);
    }

    async pageView()
    {
        //do nothing
    }

    async lead()
    {
        //do nothing
    }

    _exists(showErrors = false)
    {
        return true;
    }

    _loadScript(config)
    {
        postscribe(document.querySelector('head'), `
            <!-- Start of MouseFlow -->
            <script type="text/javascript">
                window._mfq = window._mfq || [];
                (function() {
                    var mf = document.createElement("script");
                    mf.type = "text/javascript"; mf.defer = true;
                    mf.src = "//cdn.mouseflow.com/projects/dff2ad5f-3270-43a4-9fc9-4252d4b63db5.js";
                    document.getElementsByTagName("head")[0].appendChild(mf);
                })();
            </script>
            <!-- End of MouseFlow -->
        `, {
            done: () =>
            {
                this.firstLoad = true;
                this.init(config);
            },

        });

        return true;
    }
}

export default MouseFlow;
